import React,{useEffect, useState} from 'react';
import ModalLyt from '../../../../components/Layouts/ModalLyt/ModalLyt';
import { Grid,Box,Typography,Tooltip} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import {IconButton} from '@mui/material';
import { useSelector,useDispatch } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import "../../../CompanyManagment/Copmonents/Like/Like.css";
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import DyLinearProgress from '../../../../components/GlobalComponents/DyLinearProgress/DyLinearProgress';
import CommentModal from '../../../TenantDash/LComponents/AllTenantDash/AnotherComponent ';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import { useDisLikeMeeting, useLikeMeeting } from '../../Hooks';
import OffereeFinalOpinion from '../../../AlignmentMeeting/LComponents/OffereeFinalOpinion/OffereeFinalOpinion';
import Proposer from '../../../AlignmentMeeting/LComponents/Proposer/Proposer';
import RequestRecipient from '../../../AlignmentMeeting/LComponents/RequestRecipient/RequestRecipient';
import ApplicantFinalOpinion from '../../../AlignmentMeeting/LComponents/ApplicantFinalOpinion/ApplicantFinalOpinion';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";

const SubAlignmentKrCart = (props:any) => {
  const deleteOkrState=useSelector((state:any)=>state.okrManage.okrDeleteData);
  const{mutate:likeKr,data:likeData}=useLikeMeeting()
  const{mutate:disLikeKr,data:disLikeData}=useDisLikeMeeting()
  const[showKrDetails,setShowKrDetails]=useState<Boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<any>(false);
  const[showKrRequest,setShowKrRequest]=useState<Boolean>(false);
  const[showKrRequestReciver,setShowKrRequestReciver]=useState<Boolean>(false);
  const[showKrOffer,setShowKrOffer]=useState<Boolean>(false);
  const[showKrOfferReciver,setShowKrOfferReciver]=useState<Boolean>(false);
  const tenantId=useSelector((state:any)=>state.meetings.profileTenantId);
  const [activeBtn, setActiveBtn] = useState<string>("none");

  let{item,setKrId,setIteam,setShowEditKr,setAddKrState,personPicture,meetingId}=props;
  let{responsibleName,evaluationPercentage,liked,likeCount,commentCount, periodId,
     definitionLevelId,responsibleId,cooperateId, id, objectiveId,requestPriority
    , cooperateType,fromTeam,myTeam, toTeam,check, fromTeamId,getOffer,sendOffer,getRequest,sendRequest,toOffer,toRequest, toTeamId,
    fromOffer,fromRequest, description,orgDescription ,myTeamId}:any=item;

  const [likec, setLikeCount] = useState<number>(likeCount);

const initialShowDet=()=>{
  setShowKrDetails(true);
}

const initialRequestShowDet=()=>{
  setShowKrRequest(true);
}

const initialRequestReciverShowDet=()=>{
  setShowKrRequestReciver(true);
}

const initialOfferShowDet=()=>{
  setShowKrOffer(true);
}

const initialOfferRecivedShowDet=()=>{
  setShowKrOfferReciver(true);
}

const initialEditKr=()=>{
  setKrId(cooperateId);
  setIteam(item);
  setShowEditKr(true);
}
const handleClickOpen = () => {
  setOpen(true);
};

const handleClose = () => {
  setOpen(false);
};

// const initialDeleteKr=()=>{
//   let deleteBody={
//     deletedId:id,
//     userId:userId,
//     tenantId:tenantId
// }
// callDeleteKr(deleteBody)
// handleClose();
// }


// useEffect(() => {

//   setTimeout(() => {
//     dispatch(setOkrDeleteStateR(null))
// }, 3000);

// }, [deleteOkrState])


const initialLikeKr=()=>{
  let deleteBody={
  keyResultId:cooperateId,
  tenantId:tenantId
  }
  likeKr(deleteBody)
  }

  const initialDeleteKr=()=>{
    let deleteBody={
      deletedId:id,
      //userId:userId,
      tenantId:tenantId
  }
  ///////////////////////////////////////////////////////callDeleteKr(deleteBody)
  handleClose();
  
  }

  const initialDisLikeKr=()=>{
    let deleteBody={
    keyResultId:cooperateId,
    tenantId:tenantId
    }
    disLikeKr(deleteBody)
    }

    useEffect(() => {
      if (item) {
        setLikeCount(likeCount)
        if (liked) {
          setActiveBtn("like");
        }
      }
    }, likeCount)

    const handleReactionClick = (reaction: string): void => {
      if (activeBtn === "none") {
         if (reaction === "like") {
          setLikeCount(likec + 1);
          setActiveBtn("like");
          initialLikeKr();
        }
      } else if (activeBtn === reaction) {
        if (reaction === "like") {
          setLikeCount(likec - 1);
          initialDisLikeKr();
        }
        setActiveBtn("none");
      }
      else if (activeBtn !== reaction) {
        if (reaction === "like") {
          setActiveBtn("like");
        }
      }
    };
    const [open, setOpen] = React.useState(false);
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  return (
    < >
             <Grid container boxShadow={4} borderRadius={4} p={2} >
            <Grid item xs={12}  >
           <Grid container alignItems={'center'} >
           <Grid item xs={12} sm={12}  >
            <Box    display={'flex'}
            width={'100%'}
            alignItems={'start'}
            minHeight={'50px'}
            justifyContent={'space-between'}
            >
             <Box  display={'flex'} alignItems={'center'} textAlign={'start'} 
              justifyContent={'center'}
              bgcolor={ cooperateType === "Request"?'#D5f7D4':'#bfd3f5'}   
              width={'110px'} 
              height={'28px'} 
              borderRadius={3} >
              <Typography  color={cooperateType === "Request"?'green':'blue'} 
              fontSize={'0.8rem'}  >  {
                cooperateType === "Request"?'درخواست':'پیشنهاد'}
              </Typography>
              </Box>

          <Box display={'flex'}  justifyContent={'end'}>
          <Box  display={'flex'} alignItems={'center'} textAlign={'start'} 
              justifyContent={'center'}
              bgcolor={ cooperateType === "Request" && requestPriority === "Up"?'#D5f7D4' 
                :cooperateType === "Request" && requestPriority === "Down"?'#FFEEE5' 
                :cooperateType === "Request" && requestPriority === "Normal"?'#FFF8D0' 
                :'#fff'}   
              width={'110px'} 
              height={'28px'} 
              borderRadius={3} >
              <Typography  color={ cooperateType === "Request" && requestPriority === "Up"?'green' 
                : cooperateType === "Request" && requestPriority === "Down"?'#993600' 
                : cooperateType === "Request" && requestPriority === "Normal"?'#6B6440' 
                :'#fff'} 
              fontSize={'0.8rem'}  > اولویت: {
                cooperateType === "Request" && requestPriority === "Up"?'بالا' 
                : cooperateType === "Request" && requestPriority === "Down"?'پایین' 
                : cooperateType === "Request" && requestPriority === "Normal"?'متوسط' 
                :'-'
              }
              </Typography>
              </Box>
      </Box>
            </Box>
            </Grid>
           </Grid>
            </Grid>

            <Grid container  >
            <Grid item xs={12}  sm={12} >
            <Box display={'flex'} justifyContent={'start'}  >
            {
             description?.length > 40 ? <Tooltip sx={{ fontSize: '!important' }} title={description}>
              <Typography mt={1} textAlign={'center'}  px={0.5}
              sx={{ fontSize: '!important', fontWeight:'600',color: 'black',cursor:'pointer',
                textAlign: "left",
                whiteSpace: "nowrap", // جلوگیری از شکستن خط
                overflow: "hidden", // مخفی کردن بخش‌های اضافی متن
                textOverflow: "ellipsis", // افزودن سه‌نقطه در انتها
              }}
              >{
                cooperateType === "Request"?'متن درخواست' + ': ' + description?.slice(0,40) :'شرح پیشنهاد'+ ': '  + description?.slice(0,40)
               }
              </Typography>
            </Tooltip> :
            //  <Typography mt={1} textAlign={'center'} px={0.5}
            //   sx={{ fontSize: '!important',fontWeight:'600', color: 'black',cursor:'pointer'}}
            //   >
            //   {
            //    cooperateType === "Request"?'متن درخواست' + ': ' + description :'شرح پیشنهاد'+ ': '  + description
            //   }
            // </Typography>
            <Typography 
  mt={1} 
  textAlign={'center'} 
  px={0.5}
  sx={{ 
    fontSize: " !important", 
    fontWeight: '600', 
    color: 'black', 
    cursor: 'pointer', 
    textAlign: "left", 
    whiteSpace: "nowrap", // جلوگیری از شکستن خط
    overflow: "hidden", // مخفی کردن بخش‌های اضافی متن
    textOverflow: "ellipsis", // افزودن سه‌نقطه در انتها
  }}
>
  {
    cooperateType === "Request" ? 'متن درخواست' + ': ' + description : 'شرح پیشنهاد' + ': '  + description
  }
</Typography>

       }
            </Box>

            <Box display={'flex'} justifyContent={'start'}  >
             <Typography variant='body2' fontWeight={700} >
                {
                    cooperateType === 'Request' ? "تیم درخواست کننده:" : "تیم پیشنهاد دهنده:"
                }
             </Typography>
             <Typography variant='body2' px={0.5} fontWeight={500}  >
                 {
                    myTeam
                 }
                </Typography>
            </Box>
            <Box display={'flex'} justifyContent={'start'} >
            <Typography variant='body2' fontWeight={700}>
              {cooperateType === 'Request' ? "درخواست‌ کننده:" : "پیشنهاد ‌دهنده:"}
            </Typography>
            <Typography variant='body2' px={0.5} fontWeight={500}>
              {cooperateType === 'Request' ? sendRequest : sendOffer}
            </Typography>

            </Box>
            <Box display={'flex'} justifyContent={'start'}>
              <Typography variant='body2' fontWeight={700}>
                {cooperateType === 'Request' ? " گیرنده درخواست:" : " گیرنده پیشنهاد:"}
              </Typography>
              <Typography variant='body2' px={0.5} fontWeight={500}>
              {cooperateType === 'Request' ? getRequest : getOffer}
              </Typography>
            </Box>

            <Box 
              display={'flex'} 
              justifyContent={'start'}  
              >
            <Typography 
               variant='body2' 
               fontWeight={700} >
                {
                    cooperateType === 'Request' ? "وضعیت درخواست کننده:" : "وضعیت پیشنهاد دهنده:"
                }
             </Typography>
             <Typography 
             borderRadius={3} 
              bgcolor={ 
                cooperateType === "Request" && fromRequest === 'توافق و اعمال'
                ?'#D5f7D4' :
                cooperateType === "Request" && fromRequest === 'پس گرفتن درخواست'
                ? "#FFF8D0" :
                cooperateType === "Request" && fromRequest === 'عدم توافق' 
                ? '#FFEEE5' :
                cooperateType !== "Request" && fromOffer === 'توافق و اعمال'
                ?'#D5f7D4' :
                cooperateType !== "Request" && fromOffer === 'پس گرفتن پیشنهاد'
                ? "#FFF8D0" :
                cooperateType !== "Request" && fromOffer === 'عدم توافق' 
                ? '#FFEEE5' : ''
              } 
              color={ 
                cooperateType === "Request" && fromRequest === 'توافق و اعمال'
                ?'#125610' :
                cooperateType === "Request" && fromRequest === 'پس گرفتن درخواست'
                ? "#6B6440" :
                cooperateType === "Request" && fromRequest === 'عدم توافق' 
                ? '#993600' :
                cooperateType !== "Request" && fromOffer === 'توافق و اعمال'
                ?'#125610' :
                cooperateType !== "Request" && fromOffer === 'پس گرفتن پیشنهاد'
                ? "#6B6440" :
                cooperateType !== "Request" && fromOffer === 'عدم توافق' 
                ? '#993600' : ''
              } 
                variant='body2' 
                px={0.5} 
                fontWeight={500}  >
                 {
                    cooperateType === 'Request' ? fromRequest : fromOffer
                 } 
                </Typography>
            </Box>
            <Box display={'flex'} justifyContent={'start'}  >
            <Typography variant='body2' fontWeight={700} >
                {
                    cooperateType === 'Request' ? "وضعیت گیرنده درخواست:" : "وضعیت گیرنده پیشنهاد:"
                }
             </Typography>
             <Typography 
             borderRadius={3} 
             bgcolor={ 
              cooperateType === "Request" && toRequest === 'توافق و اعمال'
              ?'#D5f7D4' :
              cooperateType === "Request" && toRequest === 'رد درخواست'
              ? "#FFF8D0" :
              cooperateType === "Request" && toRequest === 'عدم توافق' 
              ? '#FFEEE5' :
              cooperateType !== "Request" && toOffer === 'توافق و اعمال'
              ?'#D5f7D4' :
              cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
              ? "#FFF8D0" :
              cooperateType !== "Request" && toOffer === 'عدم توافق' 
              ? '#FFEEE5' : ''
            } 
            color={ 
              cooperateType === "Request" && toRequest === 'توافق و اعمال'
              ?'#125610' :
              cooperateType === "Request" && toRequest === 'رد درخواست'
              ? "#6B6440" :
              cooperateType === "Request" && toRequest === 'عدم توافق' 
              ? '#993600' :
              cooperateType !== "Request" && toOffer === 'توافق و اعمال'
              ?'#125610' :
              cooperateType !== "Request" && toOffer === 'رد پیشنهاد'
              ? "#6B6440" :
              cooperateType !== "Request" && toOffer === 'عدم توافق' 
              ? '#993600' : ''
            } 
              variant='body2' 
              px={0.5} 
              fontWeight={500}  >
                 {
                    cooperateType === 'Request' ? toRequest : toOffer
                 } 
                </Typography>
            </Box>
            </Grid>

            <Grid xs={12}  >
        <Box width={'100%'} display={'flex'} flexDirection={'row'} >
        <Grid container xs={12} justifyContent="flex-end">
  <Box display={'flex'} alignItems={'center'}>
    <Box mr={2}>
      <CommentModal id={cooperateId} name={description} commentCount={commentCount} meetingId={meetingId}/>
    </Box>
  </Box>
</Grid>
        </Box>
            </Grid>
            </Grid>
            {
              cooperateType === "Request" ?
              <Grid xs={12} sm={12} >
              <Box width={'100%'}
                display={'flex'}
                justifyContent={'end'} 
                gap={'20px'}> {/* فاصله مورد نظر */}
               <Box
             display={'flex'}
             flexDirection={'row-reverse'}
             justifyContent={'end'}  >
            <DyButton
                caption={'گیرنده درخواست'}
                onClick={initialRequestReciverShowDet}
                disabled={false}
                variant={'contained'}
                type={'button'}
                bgColor={'#00387C'}
                size="small"
                />
                </Box>
                <Box
                display={'flex'}
                flexDirection={'row-reverse'}
                justifyContent={'start'}  >
                <DyButton
                //Tooltip={'نظر نهایی درخواست دهنده'}
                caption={'درخواست دهنده'}
                disabled={!check}
                onClick={initialRequestShowDet}
                variant={'contained'}
                type={'button'}
                bgColor={'#00387C'}
                />
                </Box>
              </Box>
              </Grid>:
              <Grid xs={12} sm={12} >
              <Box width={'100%'}
                display={'flex'}
                justifyContent={'end'} 
                gap={'20px'}> {/* فاصله مورد نظر */}
            <Box
            display={'flex'}
            flexDirection={'row-reverse'}
            justifyContent={'end'}  >
            <DyButton
                caption={'پیشنهاد دهنده'}
                onClick={initialOfferRecivedShowDet}
                disabled={false}
                variant={'contained'}
                type={'button'}
                bgColor={'#00387C'}
                />
                </Box>
                <Box
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'start'}  >
                <DyButton
                //Tooltip={'نظر نهایی گیرنده پیشنهاد'}
                caption={'گیرنده پیشنهاد'}
                onClick={initialOfferShowDet}
                disabled={!check}
                variant={'contained'}
                type={'button'}
                bgColor={'#00387C'}
                />
                </Box>
            </Box>
            <Box width={'100%'}
                display={'flex'}
                justifyContent={'end'} >
            </Box>
              </Grid>
            }
             </Grid>
             <Box marginTop={3}> </Box>
              <Box marginTop={3}> </Box>
             {
                showKrRequest && <ModalLyt
                showModal={showKrRequest}
                setShowModal={setShowKrRequest}
                title={'نظر نهایی درخواست دهنده'}
                 >
                  <ApplicantFinalOpinion
                      keyResultId={id}
                      meetingId={meetingId}
                      cooperateId={cooperateId}
                      setShowToastMessage={setShowToastMessage}
                      onClose={setShowKrRequest}
                      teamId={definitionLevelId	}
                      objectiveId={objectiveId}
                      periodId={periodId} />
                </ModalLyt>
             }
              <Box marginTop={3}> </Box>
             {
                showKrRequestReciver && <ModalLyt
                showModal={showKrRequestReciver}
                setShowModal={setShowKrRequestReciver}
                title={'تعیین وضعیت (گیرنده درخواست)'}
                 >
                  <RequestRecipient
                      keyResultId={id}
                      meetingId={meetingId}
                      cooperateId={cooperateId}
                      setShowToastMessage={setShowToastMessage}
                      onClose={setShowKrRequestReciver}
                      teamId={toTeamId}
                      defId={definitionLevelId}
                      objectiveId={objectiveId}
                      periodId={periodId} />
                </ModalLyt>
             }
              <Box marginTop={3}> </Box>
             {
                showKrOffer && <ModalLyt
                showModal={showKrOffer}
                setShowModal={setShowKrOffer}
                title={'نظر نهایی گیرنده پیشنهاد'}
                 >
                  <OffereeFinalOpinion
                      keyResultId={id}
                      meetingId={meetingId}
                      cooperateId={cooperateId}
                      setShowToastMessage={setShowToastMessage}
                      onClose={setShowKrOffer}
                      objectiveId={objectiveId}
                      teamId={definitionLevelId}
                      periodId={periodId} />
                </ModalLyt>
             }
              <Box marginTop={3}> </Box>
             {
                showKrOfferReciver && <ModalLyt
                showModal={showKrOfferReciver}
                setShowModal={setShowKrOfferReciver}
                title={'تعیین وضعیت (پیشنهاد دهنده)'}
                 >
                  <Proposer
                    keyResultId={id}
                    meetingId={meetingId}
                    cooperateId={cooperateId}
                    objectiveId={objectiveId}
                    setShowToastMessage={setShowToastMessage}
                    onClose={setShowKrOfferReciver}
                    teamId={myTeamId}
                    defId={definitionLevelId}
                    periodId={periodId} />
                </ModalLyt>
             }
               <Box marginTop={3}> </Box>

               {showToastMessage && (
                <DYToastMessage
                  isSuccess={true}
                  message={'عملیات با موفقیت انجام شد'}
                  setShow={setShowToastMessage}
                  show={showToastMessage}
                />
              )}
        </>
  )
}

export default SubAlignmentKrCart